import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { Accordion, NavDropdown, ListGroup } from "react-bootstrap";
import Roles from "./Roles";
import Amenities from "./Amenities";
import ContactTypes from "./ContactTypes";
import NavbarLink from "../NavbarLink";
import { SmallSpinner } from "../../Icon";
const ControlPanel = ({ CanI, hasRole, COMPONENT }) => {
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const [state, setState] = useState({
        roles_view: false,
        roles_add: false,
        amenities_view: false,
        amenities_add: false,
        contact_types_view: false,
        contact_types_add: false
    });

    useEffect(() => {
        async function InitControlPanel() {
            const userHasAccess = await hasRole(1);
            setHasAccess(userHasAccess);
            setState({
                ...state,
                roles_view: await CanI("roles_view"),
                roles_add: await CanI("roles_add"),
                amenities_view: await CanI("amenities_view"),
                amenities_add: await CanI("amenities_add"),
                contact_types_view: await CanI("contact_types_view"),
                contact_types_add: await CanI("contact_types_add")
            });
        }
        InitControlPanel()
            .then(() => console.debug("[PANEL LOADED]"))
            .catch(() => console.debug("[PANEL LOAD FAILED]"))
            .then(() => setLoading(false));
    }, []);
    const {
        roles_view,
        roles_add,
        amenities_view,
        amenities_add,
        contact_types_view,
        contact_types_add
    } = state;

    if (loading) {
        return <SmallSpinner />;
    }
    if (!loading && !hasAccess) {
        return null;
    }

    return (
        <NavDropdown
            alignRight
            className="nav-item"
            id={"control-panel-dropdown"}
            // renderMenuOnMount={true}
            // ref={settingsRef}
            title={
                <Fragment>
                    <i className="fa fa-gear" /> Control Panel
                </Fragment>
            }
            active={COMPONENT === "admin"}
        >
            <NavDropdown.ItemText>
                <Accordion>
                    {contact_types_view && (
                        <ContactTypes contact_types_add={contact_types_add} />
                    )}
                    {roles_view && <Roles roles_add={roles_add} />}
                    {amenities_view && (
                        <Amenities amenities_add={amenities_add} />
                    )}
                </Accordion>

                <ListGroup>
                    <ListGroup.Item>
                        <NavbarLink
                            to="/app/admin"
                            className="dropdown-item"
                            label={`Administrator`}
                        />
                    </ListGroup.Item>
                </ListGroup>
                {/* <br />*/}
                {/* <ListGroup className="p-1">*/}
                {/*    <LockDown />*/}
                {/* </ListGroup>*/}
            </NavDropdown.ItemText>
        </NavDropdown>
    );
};

ControlPanel.propTypes = { CanI: PropTypes.func };
export default ControlPanel;
